export default "__VITE_ASSET__CE2YdIjU__"